<script lang="ts">
	import type { ChartConfiguration } from 'chart.js';
	import Chart from './Chart.svelte';

	interface Props {
		dividendPayoutHistory: DividendPayoutYear[];
		currency: string;
	}

	let { dividendPayoutHistory, currency }: Props = $props();

	const defaultConfig: Omit<ChartConfiguration, 'data'> = {
		type: 'bar',
		options: {
			plugins: {
				legend: {
					position: 'bottom',
					labels: {
						boxWidth: 9,
						boxHeight: 9
					}
				},
				tooltip: {
					callbacks: {
						label: function (context) {
							const label = context.dataset.label ?? '';
							if (label) {
								return `${label}: ${new Intl.NumberFormat('default', {
									style: 'currency',
									currency,
									currencyDisplay: 'narrowSymbol',
									minimumFractionDigits: 2,
									maximumFractionDigits: 6
								}).format(context.dataset.data[context.dataIndex].y!)}`;
							}
							return '';
						}
					}
				}
			},
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				y: {
					ticks: {
						callback: function (value) {
							return new Intl.NumberFormat('default', {
								style: 'currency',
								currency,
								currencyDisplay: 'narrowSymbol'
							}).format(Number(value));
						}
					}
				},
				x: {
					type: 'category',
					stacked: true,
					border: {
						display: false
					},
					grid: {
						display: false
					},
					ticks: {
						autoSkip: false,
						crossAlign: 'far'
					}
				}
			},
			indexAxis: 'x'
		}
	};

	let labels = $derived(dividendPayoutHistory.map(({ year }) => Number(year)));
	let data = $derived(
		dividendPayoutHistory
			.filter(({ forecast }) => !forecast)
			.map(({ year, total }) => ({
				y: total,
				x: Number(year)
			}))
	);
	let forecastData = $derived(
		dividendPayoutHistory
			.filter(({ forecast }) => forecast)
			.map(({ year, total }) => ({
				y: total,
				x: Number(year)
			}))
	);
</script>

<Chart
	config={{
		...defaultConfig,
		options: {
			...defaultConfig.options
		}
	}}
	data={{
		labels,
		datasets: [
			{
				label: 'Dividend per share',
				backgroundColor: '#00523D',
				borderRadius: 4,
				borderSkipped: false,
				data
			},
			...(forecastData.length
				? [
						{
							label: 'Dividend per share (Forecast)',
							backgroundColor: '#D1D1D1',
							borderRadius: 4,
							borderSkipped: false,
							data: forecastData
						}
					]
				: [])
		]
	}}
/>
